// extracted by mini-css-extract-plugin
export default {"main":"PageContent_main__RjQM7"};